var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndustry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 22V4C6 3.73 6 3.45 6.07 3.18C6.13121 2.91063 6.26673 2.66382 6.46117 2.46761C6.65562 2.27139 6.90119 2.13364 7.17 2.07C7.46 2 8.73 2 9 2H16C16.27 2 16.55 2 16.82 2.07C17.0894 2.13121 17.3362 2.26673 17.5324 2.46117C17.7286 2.65562 17.8664 2.90119 17.93 3.17C18 3.45 18 3.73 18 4V22H6Z",
    stroke: "#CCCCCC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99978 14V20C1.99978 21.1 2.89978 22 3.99978 22H5.99978V12H3.99978C3.72978 12 3.44978 12 3.17978 12.07C2.90978 12.14 2.65978 12.27 2.45978 12.47C2.26978 12.66 2.13978 12.91 2.06978 13.18C2.01333 13.4495 1.98983 13.7248 1.99978 14Z",
    stroke: "#CCCCCC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.82 9.07003C20.5505 9.01358 20.2752 8.99007 20 9.00003H18V22H20C20.5304 22 21.0391 21.7893 21.4142 21.4142C21.7893 21.0392 22 20.5305 22 20V11C22 10.72 22 10.45 21.93 10.18C21.86 9.91003 21.73 9.66003 21.53 9.46003C21.34 9.27003 21.09 9.14003 20.82 9.07003Z",
    stroke: "#CCCCCC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6H14",
    stroke: "#CCCCCC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10H14",
    stroke: "#CCCCCC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14H14",
    stroke: "#CCCCCC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18H14",
    stroke: "#CCCCCC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustry);
export default __webpack_public_path__ + "static/media/industry.aca37afda0cd46d72ceecd954e6512a1.svg";
export { ForwardRef as ReactComponent };